import { ClientDetails } from 'features/utils/types';
import { apiInstance } from './api';

export const createLead = async ({
  utm,
  ...clientDetailProps
}: ClientDetails) =>
  apiInstance.post('/createLead', {
    ...clientDetailProps,
    // createLead api does not accept utm as a prop, it's marketingCampaignRef
    marketingCampaingRef: utm,
    // isBuffered must be marked as true
    isBuffered: true,
  });
